<template>
  <div class="test-page py-8 px-4">
    <div class="max-w-7xl mx-auto">
      <h1 class="text-4xl font-bold text-white mb-8">Data Loading Test</h1>
      
      <!-- 数据加载状态 -->
      <div class="cyber-card mb-8">
        <h2 class="text-2xl font-bold text-white mb-4">Loading Status</h2>
        <div class="space-y-2">
          <p class="text-cyber-light">Loading: {{ loading }}</p>
          <p class="text-cyber-light">Games Count: {{ games.length }}</p>
          <p class="text-cyber-light">Categories Count: {{ categories.length }}</p>
        </div>
      </div>

      <!-- 游戏数据预览 -->
      <div class="cyber-card mb-8" v-if="games.length > 0">
        <h2 class="text-2xl font-bold text-white mb-4">Games Data Preview (First 5)</h2>
        <div class="space-y-4">
          <div v-for="game in games.slice(0, 5)" :key="game.name" class="border border-cyber-gray/30 p-4 rounded-lg">
            <h3 class="text-lg font-semibold text-cyber-light mb-2">{{ game.name }}</h3>
            <p class="text-cyber-light/70 text-sm mb-2">{{ game.description }}</p>
            <div class="flex gap-4 text-xs text-cyber-light/50">
              <span>Category: {{ game.category }}</span>
              <span>Date: {{ game.create_date }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 分类数据 -->
      <div class="cyber-card mb-8" v-if="categories.length > 0">
        <h2 class="text-2xl font-bold text-white mb-4">Categories</h2>
        <div class="flex flex-wrap gap-2">
          <span 
            v-for="category in categories" 
            :key="category"
            class="px-3 py-1 bg-cyber-blue/20 text-cyber-light rounded-lg text-sm"
          >
            {{ category }}
          </span>
        </div>
      </div>

      <!-- 错误信息 -->
      <div class="cyber-card" v-if="error">
        <h2 class="text-2xl font-bold text-red-400 mb-4">Error</h2>
        <p class="text-red-300">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getGames } from '@/services/gameService'

const games = ref([])
const categories = ref([])
const loading = ref(true)
const error = ref(null)

const fetchData = async () => {
  try {
    loading.value = true
    error.value = null
    
    // 获取游戏数据
    const gameData = await getGames()
    games.value = gameData || []
    
    // 获取分类
    const uniqueCategories = [...new Set(gameData.map(game => game.category))]
    categories.value = uniqueCategories.sort()
    
    console.log('Data loaded successfully:', {
      gamesCount: games.value.length,
      categoriesCount: categories.value.length,
      firstGame: games.value[0],
      categories: categories.value
    })
    
  } catch (err) {
    console.error('Failed to fetch data:', err)
    error.value = err.message || 'Failed to load data'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchData()
})
</script>

<style scoped>
.test-page {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  min-height: 100vh;
}
</style> 